{
    "TelsysList_Column_TelSysID": "ID",
    "TelsysList_Column_Description": "Descrizione",
    "TelsysList_Column_Trial": "Prova",
    "TelsysList_Trial_Yes": "SÌ",
    "TelsysList_Trial_No": "NO",
    "TelsysList_Column_PlatformType": "Tipo di piattaforma",
    "TelsysList_Column_Licence": "Licenza",
    "TelsysList_Column_Partitions": "Pareti divisorie",
    "TelsysList_Column_Extensions": "Estensioni",
    "TelsysList_Column_AcdAgents": "agenti ACD",
    "TelsysList_Column_AppUsers": "Utente dell'applicazione",
    "TelsysList_Column_Status": "Stato",
    "TelsysList_Filter_PlatformType": "Tipo di piattaforma",
    "TelsysList_Filter_ReportLicence": "Licenza di segnalazione",
    "TelsysList_Filter_ModuleStatus": "Stato del modulo",
    "TelsysList_LicenceFilter_HistoricOnly": "Solo storico",
    "TelsysList_LicenceFilter_Standard": "Standard \/ BLF",
    "TelsysList_LicenceFilter_Enterprise": "Imprese",
    "TelsysList_LicenceFilter_Acd": "ACD",
    "TelsysList_LicenceFilter_None": "Nessuno",
    "TelsysList_LicenceFilter_Mixed": "Misto",
    "TelsysList_LicenceFilter_Unknown": "Sconosciuto",
    "TelsysList_ModuleStatus_mNeg1": "Sconosciuto",
    "TelsysList_ModuleStatus_m0": "Appena avviato o chiuso",
    "TelsysList_ModuleStatus_m1": "Si è fermato",
    "TelsysList_ModuleStatus_m2": "Di partenza",
    "TelsysList_ModuleStatus_m3": "Finale",
    "TelsysList_ModuleStatus_m4": "Disabile",
    "TelsysList_ModuleStatus_m5": "In esecuzione (inattivo)",
    "TelsysList_ModuleStatus_m6": "In esecuzione (senza licenza)",
    "TelsysList_ModuleStatus_m7": "Avvio delle comunicazioni principali",
    "TelsysList_ModuleStatus_m8": "Avvio del monitoraggio del dispositivo",
    "TelsysList_ModuleStatus_m9": "Interruzione delle comunicazioni",
    "TelsysList_ModuleStatus_m10": "Corsa",
    "TelsysList_ModuleStatus_m11": "Esecuzione (avvisi)",
    "TelsysList_ModuleStatus_m12": "Sincronizzazione",
    "TelsysList_ModuleStatus_m13": "Sincronizzato",
    "TelsysList_ModuleStatus_m14": "Sincronizzato (avvisi)",
    "TelsysList_ModuleStatus_m15": "Sincronizzazione non riuscita",
    "TelsysList_ModuleStatus_m16": "Non in servizio",
    "TelsysList_ModuleStatus_m17": "Le comunicazioni si sono concluse in modo poco elegante.",
    "TelsysList_ModuleStatus_m18": "Sincronizzazione non riuscita",
    "TelsysList_ModuleStatus_m19": "Bot disabilitati",
    "TelsysList_ModuleStatus_m20": "Bot disabilitati (avvisi)",
    "TelsysList_ModuleStatus_m21": "Inattivo (autorizzazione errata)",
    "TelsysList_CountLink_PartitionsAria": "Partizioni aperte filtrate per questo server di telefonia",
    "TelsysList_CountLink_ExtensionsAria": "Interni (codici) aperti filtrati per questo server di telefonia",
    "TelsysList_CountLink_AcdAgentsAria": "Agenti ACD aperti filtrati per questo server di telefonia",
    "TelsysList_CountLink_AppUsersAria": "Utenti dell'applicazione aperta filtrati per questo server di telefonia",
    "NAME": "TelsysListLanguage"
}